@if (editMode) {
  <span>
    <dx-check-box
      [(value)]="value"
      (onValueChanged)="valueChanged($event)"
      valueChangeEvent="keyup blur change focusout"
    ></dx-check-box>
  </span>
}
@if (!editMode) {
  <span>
    <app-check-circle-widget [value]="value"></app-check-circle-widget>
  </span>
}
